<div class="flex flex-col p-5">
    <mat-dialog-content class="!px-2">
        <p>{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button
            [mat-dialog-close]="true"
            mat-flat-button
            color="primary">
            Confirm
        </button>
        <button
            mat-dialog-close
            mat-flat-button
            color="warn">
            Dismiss
        </button>
    </mat-dialog-actions>
</div>
